import React, { FC } from "react";

import { TypographyProps } from "./types";
import * as Styled from "./styles";

const Paragraph: FC<TypographyProps> = (props) => (
  <Styled.Paragraph {...props} />
);

export default Paragraph;
